import { useTranslation } from 'react-i18next'

interface AlertLogHeaderProps {
  /** Open alerts in scope, from the LIVE store — so it agrees with the header bell in fleet scope. */
  openCount: number
  /** Rows in the log before the render cap. */
  entryCount: number
  /** Pictures in the log; only meaningful in robot scope, where pictures are fetched. */
  pictureCount: number
  showPictures: boolean
  /** "{robot name} · filtered" — which population the counts describe; empty for the whole fleet. */
  scopeLabel: string
  /** The bulk pin-clear; hidden when nothing is open, because there is nothing for it to do. */
  onClearPins?: () => void
}

export function AlertLogHeader({
  openCount,
  entryCount,
  pictureCount,
  showPictures,
  scopeLabel,
  onClearPins,
}: AlertLogHeaderProps) {
  const { t } = useTranslation('console')

  return (
    <div className="flex shrink-0 items-center justify-between border-b border-gray-200 px-4 py-2 dark:border-gray-700">
      <span className="text-xs font-medium text-gray-500 dark:text-gray-400">
        {t('alerts.log.summary', '{{open}} open · {{entries}} entries', { open: openCount, entries: entryCount })}
        {showPictures && (
          <span className="text-gray-400 dark:text-gray-500">
            {' '}
            · {t('alerts.log.pictures', '{{count}} pictures', { count: pictureCount })}
          </span>
        )}
        {/* Say WHICH population this counts. The header bell counts the whole fleet, unfiltered,
            while a follow-selection element counts one robot and may drop severities on top — so
            the two legitimately disagree with nothing on screen to explain it unless the scope is
            named. */}
        {scopeLabel && <span className="text-gray-400 dark:text-gray-500"> · {scopeLabel}</span>}
      </span>
      {onClearPins && (
        <button
          type="button"
          onClick={onClearPins}
          className="rounded border border-gray-300 bg-white px-2.5 py-1 text-xs font-medium text-gray-700 hover:bg-gray-50 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700"
        >
          {t('alerts.actions.clearAll', 'Clear map pins')}
        </button>
      )}
    </div>
  )
}
